import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 830px) {
    background-color: #ffffff;
  }
`

export const Data = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: absolute;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;

  @media (max-width: 1036px) {
    top: 50%;
  }
  @media (max-width: 560px) {
    top: 50%;
  }
`

export const Header = styled.header`
  height: 100px;
  width: 100%;
  background-color: #f5f5f5;
`

export const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: row;
  background-color: #36d896;

  @media (max-width: 830px) {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const Image = styled.img`
  width: 100%;
  object-fit: cover;
  position: relative;
  left: 0px;
  top: 0px;
  max-width: 66%;
`

export const Division = styled.div`
  flex: 1;
  display: flex;

  @media (max-width: 830px) {
    display: none;
  }
`

export const Division2 = styled.div`
  position: absolute;
  top: unset;
  right: 0;
  width: 50%;
  height: 100%;
  background-color: #36d896;
  clip-path: url(#clip-shape);

  @media (max-width: 1800px) {
    width: 52.28%;
  }

  @media (max-width: 1700px) {
    width: 54.56%;
  }

  @media (max-width: 1600px) {
    width: 56.85%;
  }

  @media (max-width: 1500px) {
    width: 59.13%;
  }

  @media (max-width: 1400px) {
    width: 61.4%;
  }

  @media (max-width: 1300px) {
    width: 63.7%;
  }

  @media (max-width: 1200px) {
    width: 65.98%;
  }

  @media (max-width: 1100px) {
    width: 68.26%;
  }

  @media (max-width: 1024px) {
    width: 70%;
  }

  @media (max-width: 830px) {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    clip-path: none;
    z-index: 1000;
    top: 0;
    left: 0;
  }
`
